/**
 * Resolve an asset import to its URL under both Next.js and the Vitest runner.
 *
 * Next.js exposes static image imports as metadata objects with the URL in
 * `src`; Vite (Vitest's transformer) exposes them as URL strings. Keeping the
 * conversion here keeps bundler details out of the page markup.
 */
export function assetSrc(asset) {
  if (typeof asset === "string") return asset;
  if (asset && typeof asset.src === "string") return asset.src;
  return "";
}
